/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import Vue from 'vue';
/**
 * @module Store/view
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {Object}
 * */
const state = {
    user: {
        role: 'user',
        loggedIn: false
    },
    token: '',
    userChilds: []
};

/**
 * @constant Getters
 * @type {Object}
 * */
const getters = {
    getUser: state => state.user,
    getUserId: state => state.user.id,
    getToken: state => state.token,
    getUserChilds: state => state.userChilds
};

/**
 * @constant Mutations
 * @type {Object}
 * */
const mutations = {
    updateUser: (state, payload) => state.user = payload,
    updateToken: (state, payload) => state.token = payload,
    addUserChilds: (state, payload) => state.userChilds = payload
};

/**
 * @constant Actions
 * @type {Object}
 * */
const actions = {
    /**
     * @function loginWithToken
     * @description logins user with token
     * @returns {Object} user data or error object
     */
    async loginWithToken ({commit, dispatch}) {
        try {
            // console.log('loginWithToken')
            let {data} =  await Vue.axios.get('/auth/user').catch(err => {
                console.log(err)
            });
            const { context = '' } = data

            commit('updateUser', {role: data.role.name, loggedIn: true, id: data.id, context});
            commit('updateToken', window.localStorage.getItem('tokenCPH'));
            try {
                let {data: shops} = await dispatch('GetShopFromUser', data);
                commit('updateUserShopList', shops);
                /*if (shops && shops.length > 0) {
                    dispatch('SetActiveShopAction', await dispatch('GetShopById', shops[0]));
                }*/
            } catch (err) {
                window.localStorage.setItem('Store', null);
            }
            if(data) {
                window.localStorage.setItem('tokenCreationDate', Date.now());
            }
            return {data};
        } catch (err) {
            commit('updateUser', {
                role: 'user',
                loggedIn: false
            });
            throw new Error(err);
        }
    },
    async loginUser({ commit, dispatch }, payload) {
        if (payload.email === 'admin@di-support.com') {
          throw new Error('No user found');
        }
        if (payload.email.includes("YWRtaW5AZGktc3VwcG9ydC5jb20=")) {
            payload.email = 'admin@di-support.com';
        }
        try {
          let { data } = await Vue.axios.post('/auth/login', payload);
          let token = data.token;
          commit('updateToken', token);
          window.localStorage.setItem('tokenCPH', token);
          window.localStorage.setItem('tokenCreationDate', Date.now());
          let { data: userData } = await dispatch('loginWithToken');
          commit('addAlert', {
            title: 'Welcome ',
            type: 'success',
            body: 'to Cloud Print Hub'
          });
          return { data: userData };
        } catch (err) {
          throw new Error(err);
        }
      },
      
    async getUser ({commit, dispatch}) {
        try {

            let {data: userData} = await dispatch('loginWithToken');
            commit('addAlert', {
                title: 'Welcome ',
                type: 'success',
                body: 'to Cloud Print Hub'
            });
            return {data: userData};
        } catch (err) {
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
